import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { PlanDataService, PLANS_HELPER } from '@oneqrew-partnertool/utils';
import { selectFetchedPlans, setFetchedPlans, setPlan } from '@oneqrew-partnertool/core';
import { Observable, of } from 'rxjs';
import { tap, map, take, switchMap, filter } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Plan } from '../../../models/src';
@Injectable({ providedIn: 'root' })
export class InitailPlansResolver implements Resolve<any> {
  constructor(private planDataService: PlanDataService, private store: Store) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.store
      .select(selectFetchedPlans)
      .pipe(take(1))
      .pipe(
        switchMap((fetchedPlans) => {
          if (!fetchedPlans || fetchedPlans.length === 0) {
            const isNewCustomerPage = route.data['isNewPlanPage'] ?? false;
            return this.planDataService.getInitialPlans().pipe(
              // Hide S Paket plan on Upgrade(old customer) app
              map((fetchedPlans) => (isNewCustomerPage ? fetchedPlans : fetchedPlans.filter((p) => !PLANS_HELPER.isS_PAKET(p.planType)))),
              tap((plans: Plan[]) => {
                this.store.dispatch(setFetchedPlans({ plans }));
                if (isNewCustomerPage) {
                  this.store.dispatch(setPlan(plans[1]));
                }
              })
            );
          } else {
            return of(fetchedPlans);
          }
        })
      );
  }
}
